// import { NgModule } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FormsModule } from '@angular/forms';
// import { NgxFileDropModule } from 'ngx-file-drop';
// import { PdfViewerModule } from 'ng2-pdf-viewer';
// import { BuyerSupplierChatComponent } from './buyer-supplier-chat/buyer-supplier-chat.component';

// import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io'; 

// const socketConfig: SocketIoConfig = {
//   url: 'http://localhost:3002', // Replace with your backend WebSocket URL
//   options: {
//     transports: ['websocket'], // Specify the transport method
//   },
// };

// @NgModule({
//   declarations: [BuyerSupplierChatComponent],
//   imports: [
//     CommonModule,
//     SocketIoModule.forRoot(socketConfig),
//     NgxFileDropModule,
//     PdfViewerModule,
//     FormsModule, // needed for [(ngModel)] in the chat input
//   ],
//   exports: [BuyerSupplierChatComponent],
// })
// export class ChatModule {}



import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxFileDropModule } from 'ngx-file-drop';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BuyerSupplierChatComponent } from './buyer-supplier-chat/buyer-supplier-chat.component';

import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io'; 
import { ChatService } from './chat.service'; // Import your ChatService

const socketConfig: SocketIoConfig = {
  url: 'http://localhost:3001', // Replace with your backend WebSocket URL
  options: {
    transports: ['websocket'], // Specify the transport method
  },
};

@NgModule({
  declarations: [BuyerSupplierChatComponent],
  imports: [
    CommonModule,
    SocketIoModule.forRoot(socketConfig),
    NgxFileDropModule,
    PdfViewerModule,
    FormsModule, // needed for [(ngModel)] in the chat input
  ],
  exports: [BuyerSupplierChatComponent],
  providers: [ChatService], // Ensure ChatService is provided
})
export class ChatModule {}
